import { routeCreator } from '../../messaging-center.utils';
import {
  PAGE_TITLE as BASE_PAGE_TITLE,
  CAMPAIGN_LIST_PAGE_TITLE,
} from '../../messaging-center.constants';

export const breadcrumbLinks = [
  { to: routeCreator.base(), label: BASE_PAGE_TITLE },
  { to: routeCreator.campaignsList(), label: CAMPAIGN_LIST_PAGE_TITLE },
  { to: routeCreator.campaignCreate(), label: 'New Message' },
];

export const CREATE_BUTTON_TITLE = 'Add Message';
export const CAMPAIGN_CREATE_SUCCESS_MESSAGE =
  'SMS/Push notification configuration has been successfully created';
